// Hoist the unauthorized button — onClick uses openModal which is a stable import,
// so this JSX is completely static and safe to hoist
import { openModal } from "../../core/PopUp.tsx";
import { MODAL_LOGIN_ID } from "../../login/LoginModal.tsx";
import { IconHeart, IconHeartFilled } from "@tabler/icons-react";
import { memo } from "react";
import ItemImage from "./ItemImage.tsx";
import ItemCategory from "./ItemCategory.tsx";
import ItemBreadcrumbs from "./ItemBreadcrumbs.tsx";
import Authorized from "../../core/auth/Authorized.tsx";
import FavoriteItem from "./FaveoriteItem.tsx";
import ItemTitle from "./ItemTitle.tsx";
import ItemPrice from "./ItemPrice.tsx";
import ItemPrimaryInfos from "./ItemPrimaryInfos.tsx";

const UNAUTHORIZED_FAVORITE = (
  <button
    className="btn btn-circle"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      openModal(MODAL_LOGIN_ID);
    }}
  >
    <IconHeart />
  </button>
);

const ItemCard = memo(function ItemCard({ itemId }: { itemId: string }) {
  return (
    <div className="card w-full shadow-md bg-base-200 hover:shadow-2xl overflow-hidden">
      <figure className="relative aspect-square glass-transparent">
        <ItemImage
          className="w-full h-full aspect-square object-center"
          id={itemId}
          sizes="512px"
        />
        <div className="absolute right-0 top-0 flex flex-col items-end gap-1 h-full p-2">
          <div className="badge glass-blurry">
            <ItemCategory id={itemId} />
          </div>
          <ItemBreadcrumbs itemId={itemId} />
          <div className="grow"></div>
          <Authorized ifUnauthorized={UNAUTHORIZED_FAVORITE}>
            <FavoriteItem
              itemId={itemId}
              className="btn-circle"
              favoriteActiveChildren={<IconHeartFilled />}
              favoriteInactiveChildren={<IconHeart />}
            />
          </Authorized>
        </div>
      </figure>
      <div className="card-body relative bg-base-200">
        <div className="text-md opacity-80 flex gap-2">
          <ItemPrimaryInfos itemId={itemId} />
        </div>
        <h2 className="card-title w-full overflow-x-scroll no-scrollbar">
          <ItemTitle id={itemId} />
        </h2>
        <div className="text-md uppercase font-semibold opacity-60 grow">
          <ItemPrice id={itemId} />
        </div>
        <div className="flex justify-between"></div>
        <div className="card-actions">
          <div className="flex flex-wrap justify-between gap-0.5"></div>
        </div>
      </div>
    </div>
  );
});
export default ItemCard;
